import axios from "axios";
import { getAuth } from "firebase/auth";

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (typeof window !== "undefined") {
    const hostname = window.location.hostname || "";
    const isLocal =
      hostname.includes("localhost") || hostname.includes("127.0.0.1");

    if (isLocal) {
      return "http://127.0.0.1:5001/damia-gcp/us-central1/api";
    }
  }

  return "https://us-central1-damia-gcp.cloudfunctions.net/api";
};

const API_BASE_URL = getApiBaseUrl();

const VoiceMailService = {
  /**
   * Generate a voice mail script based on an email sample and prospect details.
   * @param {Object} params
   * @param {string} params.emailSample - The email body or summary to reference
   * @param {string} params.contactName - Prospect full name
   * @param {string} [params.contactTitle] - Prospect title
   * @param {string} [params.companyName] - Prospect company
   * @param {string} [params.contactEmail] - Prospect email address
   * @param {string} [params.sellerName] - SDR name
   * @param {string} [params.sellerRole] - SDR role
   * @param {string} [params.sellerCompany] - SDR company
   * @param {string} [params.campaignGoal] - Engagement goal
   * @returns {Promise<Object>} Voice mail payload { script, callToAction, keyPoints }
   */
  generateVoiceMail: async (params) => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      if (typeof window !== "undefined") {
        try {
          const auth = getAuth();
          const currentUser = auth.currentUser;

          if (currentUser) {
            const token = await currentUser.getIdToken(true);
            headers.Authorization = `Bearer ${token}`;
          }
        } catch (tokenError) {
          console.warn("Unable to obtain auth token for voice mail:", tokenError);
        }
      }

      const response = await axios.post(
        `${API_BASE_URL}/generateVoiceMailFromEmail`,
        params,
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error("Error generating voice mail:", error.response || error);

      const message =
        (typeof error.response?.data === "string"
          ? error.response.data
          : null) ||
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Failed to generate voice mail script. Please try again.";

      throw new Error(message);
    }
  },
};

export default VoiceMailService;

